var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaults as _defaults } from '../lang';
/**
 * 基于 localStorage 的本地存储封装类
 * - try/catch 包裹 localStorage
 * - get 时支持设置默认值
 * - set/get 时自动使用 JSON 编解码
 * - 友好的类型支持
 *
 * @example
 * ```ts
 * type UserInfo = { id: string, name: string }
 * class MyStore extends Kv {
 *   userInfo = new Field<UserInfo>(this, 'userInfo')
 * }
 * const ms = new MyStore()
 * const userInfo = ms.userInfo.get()
 * userInfo.name = 'aa'
 * ms.userInfo.set(userInfo)
 * ms.userInfo.remove()
 * ```
 */
var Kv = /** @class */ (function () {
    function Kv() {
    }
    Kv.prototype.get = function (key, defaults) {
        try {
            var store = localStorage.getItem(key);
            if (store) {
                var meta = JSON.parse(store);
                if (meta && meta.expire && Date.now() > meta.expire) {
                    this.remove(key);
                    return defaults;
                }
                return _defaults(meta.data, defaults);
            }
            return defaults;
        }
        catch (error) {
            console.warn("cannot get key:".concat(key), error);
            return defaults;
        }
    };
    Kv.prototype.set = function (key, val, options) {
        try {
            localStorage.setItem(key, JSON.stringify(__assign(__assign({}, options), { data: val })));
            return true;
        }
        catch (error) {
            console.error(error);
            return false;
        }
    };
    Kv.prototype.remove = function (key) {
        try {
            localStorage.removeItem(key);
        }
        catch (error) {
            console.error(error);
        }
    };
    return Kv;
}());
export { Kv };
/**
 * 封装了 Kv 对于某个 key 的读写删操作，可以作为自定义Kv类的属性
 */
var Field = /** @class */ (function () {
    function Field(_kv, _key, _defaults) {
        this._kv = _kv;
        this._key = _key;
        this._defaults = _defaults;
    }
    Field.prototype.get = function (defaults) {
        if (defaults === void 0) { defaults = this._defaults; }
        return this._kv.get(this._key, defaults);
    };
    Field.prototype.set = function (val, options) {
        return this._kv.set(this._key, val, options);
    };
    Field.prototype.remove = function () {
        return this._kv.remove(this._key);
    };
    return Field;
}());
export { Field };
//# sourceMappingURL=kv.js.map